import { Component, TemplateRef } from '@angular/core';
import { ToastService } from './toast.service';
import { Toast } from './toast.model';

@Component({
  selector: 'app-toasts',
  standalone: false,
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent {

  constructor(public toastService: ToastService) { }

  isTemplate(toast: Toast) {
    return toast.textOrTpl instanceof TemplateRef;
  }

}
